import { render, staticRenderFns } from "./srPhotoUploader.vue?vue&type=template&id=5fbbdb79&scoped=true"
import script from "./srPhotoUploader.vue?vue&type=script&lang=js"
export * from "./srPhotoUploader.vue?vue&type=script&lang=js"
import style0 from "./srPhotoUploader.vue?vue&type=style&index=0&id=5fbbdb79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbbdb79",
  null
  
)

export default component.exports